import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * One tool's former address under the cross-BU list (NAV-84), kept
 * resolvable for links already sent around. See `products.tsx` for why the
 * segment moved.
 */
export const Route = createFileRoute("/group-legal/products_/$productKey")({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/group-legal/tools/$productKey",
      params,
      search,
      replace: true,
    });
  },
});
